import { useEffect, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
// Acromegaly React components
import MDBox from "components/MDBox";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay";
// Acromegaly React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PropTypes from "prop-types";
// Acromegaly React contexts
import { useMaterialUIController, setDirection } from "context";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { getCollaboratorWagesList } from "controllers/OrderController";
import MDTypography from "components/MDTypography";
import AdapterJalali from "@date-io/date-fns-jalali";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { getCollaboratorWagesDetailsList } from "controllers/OrderController";

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5, direction: "rtl" }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="صفحه اول">
        <LastPageIcon />
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="اخرین صفحه"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="صفحه قبلی"
      >
        <FirstPageIcon />
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const filters = {
  fromDate: "",
  toDate: "",
  collaborator: false,
};

const sorts = {};
const platings = ["بدون آبکاری", "طلایی", "رزگلد", "رادیوم"];

function Collaborator() {
  const [controller, dispatch] = useMaterialUIController();
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [filter, setFilter] = useState(filters);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState(sorts);

  const [page, setPage] = useState(0);
  const [datas, setDatas] = useState([]);
  const [sumWeges, setSumWeges] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { userid, name, mode } = useParams();
  const navigate = useNavigate();
  let emptyRows = rowsPerPage - Math.min(rowsPerPage, count - page * rowsPerPage);

  // Avoid a layout jump when reaching the last page with empty rows.
  const getData = async (perPagex, pagex, filterx, searchx, sortx) => {
    setLoading(true);
    setDatas([]);

    const data = await getCollaboratorWagesDetailsList(
      perPagex,
      pagex,
      searchx,
      filterx,
      sortx,
      userid,
      mode,
      controller.token
    );

    if (data.success) {
      setDatas(data.data);
      if (mode + "" == "2") {
        setSumWeges(data.profit);
      } else {
        setSumWeges(data.sum);
      }
      setCount(data.count);
      emptyRows = rowsPerPage - Math.min(rowsPerPage, datas.length - (pagex - 1) * rowsPerPage);
    } else {
      Swal.fire({
        text: data.message,
        icon: "error",
        confirmButtonText: "بسیار خوب",
      });

      if (data.code === 401) {
        navigate("/", { replace: true });
      }
    }

    setLoading(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(rowsPerPage, newPage + 1, filter, search, sort);
  };
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setFilter("");
    getData(parseInt(event.target.value, 10), 1, filter, search, sort);
  };

  useEffect(() => {
    setDirection(dispatch, "rtl");
    // if (!controller.authenticated) {
    //   Swal.fire({
    //     text: "برای دسترسی به این صفحه باید وارد حساب کاربری خود شوید",
    //     icon: "error",
    //     confirmButtonText: "بسیار خوب",
    //   });
    //   navigate("/", { replace: true });
    // } else {
    //   getData(10, 1, filter, "");
    // }
    getData(10, 1, filter, "", sort);
  }, []);
  useEffect(() => {
    setDirection(dispatch, "rtl");
    // if (!controller.authenticated) {
    //   Swal.fire({
    //     text: "برای دسترسی به این صفحه باید وارد حساب کاربری خود شوید",
    //     icon: "error",
    //     confirmButtonText: "بسیار خوب",
    //   });
    //   navigate("/", { replace: true });
    // } else {
    //   getData(10, 1, filter, "");
    // }
    getData(10, 1, filter, "", sort);
  }, [mode, ]);
   
  return (
    <DashboardLayout>
      <DashboardNavbar
        title={userid == "635682d06ceb014b0abbad6d" ? `حسابداری مشتری` : " حسابداری همکاران"}
      />

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <Grid container>
                  <Grid item xs={6} sm={6}>
                    <MDTypography variant="h6" fontWeight="medium" color="white">
                      {userid == "635682d06ceb014b0abbad6d"
                        ? `حسابداری مشتری`
                        : ` حسابداری همکاران گرامی :  ${name} `}
                    </MDTypography>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <MDTypography variant="h6" fontWeight="medium" color="white">
                      {userid == "635682d06ceb014b0abbad6d" &&
                        `مجموع سود : ${numberWithCommas(sumWeges)}  تومان`}
                      {userid !== "635682d06ceb014b0abbad6d" &&
                        `مجموع اجرت کل : ${numberWithCommas(sumWeges)}  تومان`}
                    </MDTypography>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox pt={3}>
                <LoadingOverlay
                  className="overlayclass"
                  active={loading}
                  spinner
                  text="لطفا کمی صبر کنید"
                >
                  <Grid container spacing={1} mr={1} ml={1}>
                    <Grid item lg={2} md={5} xs={5}>
                      <LocalizationProvider dateAdapter={AdapterJalali}>
                        <DatePicker
                          label="از تاریخ "
                          mask="____/__/__"
                          value={filter.fromDate}
                          onChange={(newValue) => {
                            const temp = filter;
                            temp.fromDate = newValue;
                            setFilter(temp);
                            getData(rowsPerPage, 1, filter, search, sort);
                          }}
                          renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item lg={2} md={5} xs={5}>
                      <LocalizationProvider dateAdapter={AdapterJalali}>
                        <DatePicker
                          label="تا تاریخ"
                          mask="____/__/__"
                          value={filter.toDate}
                          onChange={(newValue) => {
                            const temp = filter;
                            temp.toDate = newValue;
                            setFilter(temp);
                            getData(rowsPerPage, 1, filter, search, sort);
                          }}
                          renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item lg={2} md={5} xs={5}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="material">جنس محصول</InputLabel>
                        <Select
                          dir="rtl"
                          id="material"
                          labelId="label-material"
                          label="جنس محصول"
                          onChange={(event) => {
                            const temp = filter;
                            temp.material = event.target.value;
                            setFilter(temp);
                            getData(rowsPerPage, 1, filter, search, sort);
                          }}
                        >
                          <MenuItem>
                            <em>NONE</em>
                          </MenuItem>
                          <MenuItem value="طلا">طلا</MenuItem>
                          <MenuItem value="نقره">نقره</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item lg={2} md={5} xs={5}>
                      <FormControl fullWidth variant="outlined">
                        <InputLabel id="plating">آبکاری</InputLabel>
                        <Select
                          dir="rtl"
                          id="plating"
                          labelId="label-plating"
                          label="آبکاری"
                          value={filter.plating}
                          onChange={(event) => {
                            const temp = filter;
                            temp.plating = event.target.value;
                            setFilter(temp);
                            getData(rowsPerPage, 1, filter, search, sort);
                          }}
                        >
                          <MenuItem>
                            <em>NONE</em>
                          </MenuItem>
                          {platings.map((item) => (
                            <MenuItem value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid container px={1} mt={1} spacing={1}>
                    <Grid item lg={2} md={3} xs={3}>
                      {sort.collaboratorDate && sort.collaboratorDate === 1 && (
                        <Button
                          endIcon={<ArrowDownwardIcon />}
                          onClick={() => {
                            const temp = sort;
                            temp.collaboratorDate = undefined;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          تاریخ تحویل به همکار
                        </Button>
                      )}
                      {sort.collaboratorDate && sort.collaboratorDate === -1 && (
                        <Button
                          endIcon={<ArrowUpwardIcon />}
                          onClick={() => {
                            const temp = sort;
                            temp.collaboratorDate = 1;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          تاریخ تحویل به همکار
                        </Button>
                      )}
                      {(!sort.collaboratorDate || !sort.collaboratorDate) && (
                        <Button
                          onClick={() => {
                            const temp = sort;
                            temp.collaboratorDate = -1;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          تاریخ تحویل به همکار
                        </Button>
                      )}
                    </Grid>

                    <Grid item lg={2} md={3} xs={3}>
                      {sort.thickness && sort.thickness === 1 && (
                        <Button
                          endIcon={<ArrowDownwardIcon />}
                          onClick={() => {
                            const temp = sort;
                            temp.thickness = undefined;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          ضخامت
                        </Button>
                      )}
                      {sort.thickness && sort.thickness === -1 && (
                        <Button
                          endIcon={<ArrowUpwardIcon />}
                          onClick={() => {
                            const temp = sort;
                            temp.thickness = 1;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          ضخامت
                        </Button>
                      )}
                      {(!sort.thickness || !sort.thickness) && (
                        <Button
                          onClick={() => {
                            const temp = sort;
                            temp.thickness = -1;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          ضخامت
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                  <TableContainer component={Paper} style={{ borderWidth: 1, borderColor: "#000" }}>
                    <Table>
                      <TableBody>
                        {/* <TableRow style={{ backgroundColor: "#ccc" }}>
                          <TableCell>
                          </TableCell>
                        </TableRow> */}
                        {datas.map((row) => (
                          <TableRow
                            sx={{ "& > *": { borderBottom: "unset" } }}
                            key={row.name}
                            style={{
                              borderWidth: 1,
                              borderColor: "#000",
                              borderRadius: 5,
                            }}
                          >
                            <TableCell>
                              <div className="borderdtbltr">
                                <Grid
                                  className="tblhrader"
                                  container
                                  px={1}
                                  onClick={() => {
                                    ///neworder/0/635d5d4371b92252767c2bc6/1
                                    let endUser = "0";
                                    if (userid == "635682d06ceb014b0abbad6d") {
                                      endUser = "1";
                                    }
                                    navigate(`/neworder/${endUser}/${row.id}/1`);
                                  }}
                                >
                                  <Grid container lg={12} md={12} xs={12}>
                                    {userid !== "635682d06ceb014b0abbad6d" && (
                                      <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                        <b style={{ color: "#000066" }}> تاریخ تحویل : </b>
                                        {row.collaboratorDate}
                                      </Grid>
                                    )}
                                    {userid == "635682d06ceb014b0abbad6d" && (
                                      <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                        <b style={{ color: "#000066" }}> تاریخ تحویل به مشتری : </b>
                                        {row.endDate}
                                      </Grid>
                                    )}

                                    <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                      <b style={{ color: "#000066" }}> جنس محصول: </b>
                                      {row.material}
                                    </Grid>
                                    <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                      <b style={{ color: "#000066", minWidth: 180 }}> نوع ساخت: </b>
                                      {row.buildType}
                                    </Grid>

                                    <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                      <b style={{ color: "#000066", minWidth: 180 }}>
                                        وزن تحویلی :{" "}
                                      </b>
                                      {userid == "635682d06ceb014b0abbad6d"
                                        ? row.endWeight
                                          ? row.endWeight + " gr "
                                          : ""
                                        : row.collaboratorWeight
                                        ? row.collaboratorWeight + " gr "
                                        : ""}
                                    </Grid>
                                    <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                      <b style={{ color: "#000066", minWidth: 180 }}>شرح محصول:</b>
                                      {row.explanation}
                                    </Grid>
                                    {userid == "635682d06ceb014b0abbad6d" && (
                                      <>
                                        <Grid
                                          item
                                          lg={4}
                                          md={6}
                                          xs={12}
                                          style={{ textAlign: "right" }}
                                        >
                                          <b style={{ color: "#000066", minWidth: 180 }}> سود: </b>
                                          {numberWithCommas(row.profit)}
                                          <b> تومان </b>
                                        </Grid>
                                        <Grid
                                          item
                                          lg={4}
                                          md={6}
                                          xs={12}
                                          style={{ textAlign: "right" }}
                                        >
                                          <b style={{ color: "#000066", minWidth: 180 }}>
                                            مشتری نهایی:
                                          </b>
                                          {row.endUserName}
                                        </Grid>
                                        <Grid
                                          item
                                          lg={4}
                                          md={6}
                                          xs={12}
                                          style={{ textAlign: "right" }}
                                        >
                                          <b style={{ color: "#000066", minWidth: 180 }}>
                                            شماره فاکتور:
                                          </b>
                                          {row.factorNumber}
                                        </Grid>
                                      </>
                                    )}
                                    {userid !== "635682d06ceb014b0abbad6d" && (
                                      <Grid
                                        item
                                        lg={4}
                                        md={4}
                                        xs={12}
                                        style={{ textAlign: "right" }}
                                      >
                                        <b style={{ color: "#000066", minWidth: 180 }}> اجرت: </b>
                                        {numberWithCommas(row.wages)}
                                        <b> تومان </b>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                        {emptyRows > 0 && (
                          <TableRow style={{ height: 0 }}>
                            <TableCell />
                          </TableRow>
                        )}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: "همه", value: -1 }]}
                            count={count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                              inputProps: {
                                "aria-label": "سطر در هر صفحه",
                              },
                              native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                </LoadingOverlay>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Collaborator;
